// extracted by mini-css-extract-plugin
export default {"innerWrapper":"xs-z","tooltipWrapper":"ys-z","icon":"zs-z","tooltip":"As-z","content":"Bs-z"};